import client from "@/utils/apiClient.js";

class SearchApiService {
    /* 検索用 */
    getAllResults(params) {
        //return client.get("/json/metadata_all_search.json");
        return client.get("/metadata/all/search", params);
    }

    getPaperResults(params) {
        //return client.get("/json/tests/metadata_paper_search.json");
        return client.get("/metadata/paper/search", params);
    }

    getJournalResults(params) {
        //return client.get("/json/tests/metadata_journal_list.json");
        return client.get("/browse/journal/list", params);
    }

    getJournalVolumesResults(params) {
        //return client.get("/json/tests/metadata_journal_volume.json");
        return client.get("/browse/journal/volumes", params);
    }

    getJournalPaperResults(params) {
        //return client.get("/json/tests/metadata_browse_journal_papers.json");
        return client.get("/browse/journal/papers", params);
    }

    getHinshuResults(params) {
        //return client.get("/json/tests/metadata_hinshu_search.json");
        return client.get("/metadata/hinshu/search", params);
    }

    getNoukiguResults(params) {
        //return client.get("/json/tests/metadata_noukigu_search.json");
        return client.get("/metadata/noukigu/search", params);
    }

    /* パーマリンク用 */
    // 所蔵情報表示機能は削除対応のためコメントアウト
    // getCollection(aid) {
    //     //return client.get("/json/tests/permalink_get_collection.json");
    //     return client.get("/permalink/get-collection/" + aid);
    // }

    /* ファセット用 */
    getAllFacet(params) {
        /*
        let facetName = "UNSET";
        if (facetName === "catyear")
            return client.get("/json/metadata_all_facet_catyear.json");
        if (facetName === "dbname")
            return client.get("/json/metadata_all_facet_dbname.json");
        */
        return client.get("/metadata/all/facet", params);
    }

    getPaperFacet(params) {
        /*
        let facetName = "UNSET";
        if (facetName === "catperson")
            return client.get(
                "/json/tests/metadata_paper_facet_catperson.json"
            );
        if (facetName === "jtitle")
            return client.get("/json/tests/metadata_paper_facet_jtitle.json");
        if (facetName === "catyear")
            return client.get("/json/tests/metadata_paper_facet_catyear.json");
        if (facetName === "catlang")
            return client.get("/json/tests/metadata_paper_facet_catlang.json");
        */
        // return client.get("/json/metadata_paper_facet.json");
        return client.get("/metadata/paper/facet", params);
    }

    getHinshuFacet(params) {
        //return client.get("/json/tests/metadata_hinshu_facet.json");
        return client.get("/metadata/hinshu/facet", params);
    }

    getNoukiguFacet(params) {
        /*
        let facetName = "UNSET";
        if (facetName === "catyear")
            return client.get(
                "/json/tests/metadata_noukigu_facet_catyear.json"
            );
        if (facetName === "catplace")
            return client.get(
                "/json/tests/metadata_noukigu_facet_catplace.json"
            );
        */
        // return client.get("/json/metadata_noukigu_facet.json");
        return client.get("/metadata/noukigu/facet", params);
    }

    /* ダウンロード用(POST処理) */
    // paper
    downloadPaper(params) {
        return client.post("/metadata/paper/download", params.params);
    }
    // hinshu
    downloadHinshu(params) {
        return client.post("/metadata/hinshu/download", params.params);
    }
    // noukigu
    downloadNoukigu(params) {
        return client.post("/metadata/noukigu/download", params.params);
    }

    /* DP203 getFullText用 */
    getFullText(rn) {
        //return client.get("/json/tests/get-fulltext-link_metadata_id.json");
        return client.get("/widget/link-resolver/get-fulltext-link", rn);
    }

    /* カテゴリ取得用 */
    // 検索フォームの選択肢として使用する
    getHinshuAllCategory() {
        //return client.get("/json/tests/mordal_hinshu_crop.json");
        return client.get("/metadata/hinshu/category");
    }

    getNoukiguAllCategory() {
        //return client.get("/json/tests/mordal_noukigu_category.json");
        return client.get("/metadata/noukigu/category");
    }

    getNoukiguMajorCategory() {
        //return client.get("/json/tests/metadata_noukigu_category_major.json");
        return client.get("/metadata/noukigu/category/major");
    }

    getNoukiguMiddleCategory(majorcategory) {
        /*
        let major = "";
        if(major === "ブラウ"){
            return client.get("/json/tests/metadata_noukigu_category_no_middle.json");
        }else{
            return client.get("/json/tests/metadata_noukigu_category_middle.json");
        }
        */
        return client.get("/metadata/noukigu/category/middle/" + majorcategory);
    }

    /* お知らせ用 */
    getNews(newsid) {
        //return client.get("/json/tests/sample.json");
        return client.get("/common/news/" + newsid);
    }

    getNewsList() {
        //return client.get("/json/tests/sample.json");
        return client.get("/common/news");
    }
}

export default new SearchApiService();
